import {
    Object3D,
    BoxBufferGeometry,
    Mesh, Box3, Vector3, SubtractiveBlending
} from 'three';
import { component } from 'bidello';
import * as THREE from 'three';
import TWEEN from 'three/examples/jsm/libs/tween.module.min';


export class Building extends component(Object3D) {

    init(){

        this.buildingMesh = null;
        this.supportMesh = null;
        this.originalPosition = new Vector3();
        this.fadeOutTween = null;
        this.fadeInTween = null;
        this.moveTween = null;

    }



    attachMesh(mesh){

        mesh.parent = this;
        console.log (mesh, "after attahcmeent ")
        mesh.children.map((child)=>{



            if (child.name == "building_0") this.attachBuildingMesh(child);
            if (child.name == "building_1") this.attachSupportMesh(child);

        })

        this.add(mesh);
        this.buildingMesh = mesh;
        this.buildingMesh.material.transparent = true;
        this.buildingMesh.material.blendingMode = SubtractiveBlending
        this.buildingMesh.material.alphaTest = 0;
        this.buildingMesh.material.opactiy = 0;
        this.fadeOutTween = new TWEEN.Tween(this.buildingMesh.material).easing(TWEEN.Easing.Exponential.InOut);
        this.fadeInTween = new TWEEN.Tween(this.buildingMesh.material).easing(TWEEN.Easing.Exponential.InOut);
        this.moveTween = new TWEEN.Tween(this.position).easing(TWEEN.Easing.Exponential.InOut);
        this.originalPosition.copy(this.position);

    }

    attachBuildingMesh (mesh){

        this.buildingMesh = mesh;
        this.buildingMesh.material.transparent = true;
        this.buildingMesh.material.blendingMode = SubtractiveBlending
        this.buildingMesh.material.alphaTest = 0;
        this.buildingMesh.material.opactiy = 0;
        this.fadeOutTween = new TWEEN.Tween(this.buildingMesh.material).easing(TWEEN.Easing.Exponential.InOut);
        this.fadeInTween = new TWEEN.Tween(this.buildingMesh.material).easing(TWEEN.Easing.Exponential.InOut);
        this.moveTween = new TWEEN.Tween(this.position).easing(TWEEN.Easing.Exponential.InOut);

    }

    attachSupportMesh (mesh){

        this.supportMesh = mesh;
        this.supportMesh.material.transparent = true;
        this.supportMesh.material.blendingMode = SubtractiveBlending
        this.supportMesh.material.alphaTest = 0;
        this.supportMesh.material.opactiy = 0;


    }



    getCenter(){

        const box = new Box3().setFromObject(this.meshModel);
        return box.getCenter(new Vector3());

    }

    getSizeBox (){

        const box = new Box3().setFromObject(this.meshModel);
        return  box.getSize(new Vector3());

    }


    fadeOut (time = 3000){

        this.fadeInTween.to({opacity:0},time).start()


    }

    fadeIn(time = 3000){

        console.log(this.buildingMesh,'< is null ?')
        this.fadeInTween.to({opacity:1},time).start()


    }

    dropDown (){

        this.moveTween.to({y:-15},700).start();

    }

    restore (){

        this.moveTween.to({y:0},700).start();

    }



}



